module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAlElEQVRIx2NgKNKkFRo1Gg39pxmgpdGXBEyIRNeU9IGIePUkGP00Th6IaGL057m8QERNo+97qP7cyv57D+v/swxABGQAuUBB6rj6pq7Oj/Wc/88xABGQAeRSM0A+zeSHGP1pOj81w/qqrOGv3azAQHjgqQJkXJEypJrRN/V0rilCk911Fb0b2rpEGT00c+NooUo3owFeAwpT9HVLJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/sr.png
// module id = 386
// module chunks = 0